import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';

const DLATradeAwardsYear = () => {
  const { year } = useParams();
  const navigate = useNavigate();
  const [selectedImg, setSelectedImg] = useState(null);
  const [awardImages, setAwardImages] = useState([]);
  const [categoryInfo, setCategoryInfo] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  // Initialize axios instance
  const api = axios.create({
    baseURL: "https://backend.dlapakistan.com/api/dla-trade",
    headers: { "Content-Type": "application/json" },
    timeout: 10000,
  });

  useEffect(() => {
    const fetchAwardData = async () => {
      if (!year) {
        setError('Year parameter is missing.');
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        setError('');
        setAwardImages([]);
        setCategoryInfo(null);
        
        // GET CATEGORY BY YEAR
        const categoryResponse = await api.get(`/trade-awards/categories/?year=${year}`);
        
        if (categoryResponse.data && categoryResponse.data.length > 0) {
          const category = categoryResponse.data[0];
          setCategoryInfo(category);
          
          // GET IMAGES FOR THIS CATEGORY
          const imagesResponse = await api.get(`/trade-awards/images/?category_id=${category.id}`);
          setAwardImages(imagesResponse.data || []);
          
          if (imagesResponse.data.length === 0) {
            setError(`No images found for ${year}.`);
          }
        } else {
          setError(`No award category found for year ${year}.`);
        }
        
      } catch (error) {
        console.error('Error:', error);
        setError('Failed to load data.');
      } finally {
        setLoading(false);
      }
    };

    fetchAwardData();
  }, [year]);

  const handleBackToAwards = () => {
    navigate('/dlatrade/awards');
  };

  const getCategoryDisplayName = () => {
    if (!categoryInfo) return `DLA Trade Awards ${year}`;
    return `${categoryInfo.name} ${categoryInfo.year}`;
  };

  return (
    <div className="max-w-7xl mx-auto p-6 font-sans text-[#333333]">


   

      <h1 className="text-[42px] font-normal mb-4 text-[#3c4858]">{getCategoryDisplayName()}</h1>
      <hr className="border-t border-gray-200 mb-10" />

      {loading ? (
        <div className="flex justify-center items-center py-20">
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-[#70B444]"></div>
        </div>
      ) : error ? (
        <div className="text-center py-20">
          <p className="text-gray-600 text-lg">No award images found for {getCategoryDisplayName()}</p>
        </div>
      ) : awardImages.length === 0 ? (
        <div className="text-center py-20">
          <p className="text-gray-600 text-lg">No award images found for {getCategoryDisplayName()}</p>
        </div>
      ) : (
        <>
          <div className="mb-4">
            <h2 className="text-[24px] text-[#70B444] font-normal">{year}</h2>
          </div>

          <p className="text-[17px] mb-12 text-[#555555]">
            The {year} DLA Trade Winners were:
          </p>

          {/* UPDATED: EVEN SMALLER IMAGES - 120px width */}
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-y-12 gap-x-6 max-w-4xl mx-auto">
            {awardImages.map((image, index) => (
              <div key={image.id} className="flex justify-center items-center">
                <img 
                  src={image.image_url} 
                  alt={`Award Winner ${index + 1}`} 
                  className="w-full max-w-[120px] h-auto object-contain cursor-pointer transition-transform duration-300 hover:scale-110" 
                  onClick={() => setSelectedImg(image.image_url)}
                  onError={(e) => {
                    e.target.src = "https://via.placeholder.com/120x180/70B444/FFFFFF?text=Award";
                    e.target.alt = "Image not available";
                  }}
                />
              </div>
            ))}
          </div>

          <div className="mt-12 pt-8 border-t border-gray-200 text-center">
            <p className="text-gray-600">
              {awardImages.length} award {awardImages.length === 1 ? 'image' : 'images'} for {getCategoryDisplayName()}
            </p>
          </div>
        </>
      )}

      {selectedImg && (
        <div 
          className="fixed inset-0 bg-black bg-opacity-80 z-50 flex items-center justify-center p-4 cursor-zoom-out"
          onClick={() => setSelectedImg(null)}
        >
          <div className="relative max-w-4xl w-full flex justify-center">
            <button 
              className="absolute -top-10 right-0 text-white text-3xl font-bold hover:text-[#70B444]"
              onClick={() => setSelectedImg(null)}
            >
              ×
            </button>
            <img 
              src={selectedImg} 
              className="max-h-[90vh] max-w-full rounded shadow-2xl" 
              alt="Enlarged Award"
            />
          </div>
        </div>
      )}
    </div>
  );
};

export default DLATradeAwardsYear;